export { default as ImageWithText } from './ImageWithText'
export { default as imageWithTextFactory } from './ImageWithTextFactory'
